// extracted by mini-css-extract-plugin
export var actionButton = "_8k-1";
export var actionButtons = "_8k-2";
export var actions = "_8k-0";
export var aiUnread = "_8k-10";
export var alignCenter = "_8k-h";
export var backWrapper = "_8k-3";
export var cellContainer = "_8k-4";
export var checkboxContainer = "_8k-5";
export var contentContainer = "_8k-6";
export var contentHeader = "_8k-8";
export var conversationsTableWrapper = "_8k-s";
export var draftReplyBadgeContainer = "_8k-m";
export var dropdownItem = "_8k-b";
export var dropdownItemsContainer = "_8k-a";
export var dropdownTitle = "_8k-c";
export var errorIcon = "_8k-7";
export var filter = "_8k-d";
export var gray = "_8k-i";
export var headerActionButtons = "_8k-e";
export var headerCheckboxContainer = "_8k-f";
export var icon = "_8k-j";
export var menuContainer = "_8k-k";
export var noMoreTicketsIcon = "_8k-12";
export var noMoreTicketsSubText = "_8k-13";
export var oneLine = "_8k-l";
export var optionsButton = "_8k-n";
export var plus = "_8k-o";
export var portalButtonsWrapper = "_8k-g";
export var red = "_8k-p";
export var scrolledTop = "_8k-9";
export var search = "_8k-q";
export var selectedConversationsCount = "_8k-r";
export var spinner = "_8k-t";
export var strong = "_8k-u";
export var summaryCell = "_8k-v";
export var tableContainer = "_8k-11";
export var tagContainer = "_8k-w";
export var threeDots = "_8k-x";
export var twoLines = "_8k-y";
export var unread = "_8k-z";